import { PayloadAction } from "@reduxjs/toolkit";
import { VendorsState } from "../../models/VendorsState";
import { GetVendorsPayload } from "../../payload/GetVendors/GetVendorsPayload";

const getVendorsFetch = (state: VendorsState, action: PayloadAction<GetVendorsPayload>) => {
    state.isLoading = true;
}

export default getVendorsFetch;